import { TimeGrid } from 'interfaces/timegrid.interface';

interface PlanningWarningTileProps {
  className?: string;
  timegrid: TimeGrid;
  selected: boolean
  onClick: ( timegrid: TimeGrid ) => void
}

const PlanningWarningTileComponent = ( {
  className = '',
  selected = false,
  timegrid,
  onClick
} : PlanningWarningTileProps ) => {
  return (
    <div className={ `
      ${ className }
      group relative w-full min-w-0 overflow-hidden rounded-xl border p-2.5 text-slate-700 transition-all duration-200 ease-out cursor-pointer
      ${ selected
      ? 'border-sky-300 bg-sky-50 shadow-[0_8px_18px_rgba(59,130,246,0.08)]'
      : 'border-sky-200 bg-white hover:border-sky-300 hover:bg-sky-50 hover:-translate-y-0.5 hover:shadow-[0_8px_16px_rgba(15,23,42,0.05)]'
    }
    ` }
    onClick={ () => { onClick( timegrid ); } }
    >
      <div className='absolute inset-y-0 left-0 w-1 bg-sky-400' />
      <p className='relative w-full text-sm font-medium text-slate-700 break-words whitespace-normal text-center overflow-wrap-anywhere'> { timegrid.name } </p>
    </div>
  );
};

export default PlanningWarningTileComponent;